<template>
	<div id="app">

		<router-view/>
	</div>
</template>

<script>
	export default {
		name: 'App'
	}
</script>

<style lang="less">
	#app {
		font-family: 'Avenir', Helvetica, Arial, sans-serif;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	
	.app {
		height: 100vh;
		overflow: scroll;
	}
	
	@w: 19.2vw;
	/*公用标题*/
	
	.comtit {
		width: 300/@w;
		min-width: 180px;
		background: #fff;
		margin: 40px auto;
		text-align: center;
		z-index: 2;
		-webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, .2);
		box-shadow: 0 15px 30px rgba(0, 0, 0, .2);
		-webkit-transform: translate3d(0, -2px, 0);
		transform: translate3d(0, -2px, 0);
		padding: 15px;
		border-radius: 10px;
		span {
			display: block;
			color: #616161;
			font-size: 22/@w;
			&:nth-child(2) {
				color: #D8D8D8;
				font-size: 16/@w;
			}
		}
	}
	
	.fontHidden2 {
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
	}
	
	.fontHidden3 {
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
	}
	
	.fontHidden1 {
		white-space: normal;
		overflow: hidden;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 1;
	}
	
	.header_b {
		position: relative;
		.nav_x {
			background: url("../static/images/nav-x.png") no-repeat center;
			background-size: 100% 100%;
			position: absolute;
			left: 0;
			bottom: 12px;
			padding: 6/@w 50/@w;
			display: inline-block;
			span {
				display: inline-block;
				font-size: 16/@w;
				vertical-align: middle;
				color: #C3BEBE;
				img {
					width: 24/@w;
					min-width: 16px;
				}
				a {
					color: #FBF4E9;
					text-decoration: none;
				}
				a:hover {
					color: #F34747;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/App.vue